/**
 * Короткие подписи канала сообщения для компактных лент (KAN-717).
 * Полный бейдж с иконкой: components/dashboard/ChannelBadge.
 */
import type { MessageSource } from '@/services/api/dashboard'

const SHORT_LABELS: Record<MessageSource, string> = {
  web: 'Web',
  telegram: 'TG',
  voice: 'Голос',
  email: 'Почта',
  max: 'MAX',
}

/** Короткая подпись канала сообщения; неизвестный канал - Web. */
export function channelShortLabel(source: string | null | undefined): string {
  return SHORT_LABELS[source as MessageSource] ?? SHORT_LABELS.web
}
